import React, { PureComponent } from 'react';
import get from 'lodash/get';
import { message } from 'antd';

import Modal from '../../../../../components/Modal';
import P from '../../../../../components/P';
import { createCustomerNote } from '../api';
import BookingPageContext from '../../../context';

class MuteFeedbackModal extends PureComponent {
  static contextType = BookingPageContext;

  state = {
    confirmLoading: false,
  };

  muteFeedback = async () => {
    const { authUser, booking, closePopup } = this.props;

    const note = {
      ownerType: 'booking',
      content: 'Mute feedback',
      noteType: 'no-trustpilot',
      generatedBy: authUser?.name && authUser?.surname ? `${authUser.name} ${authUser.surname}` : authUser?.username,
    };

    try {
      this.setState({ confirmLoading: true });
      const { data } = await createCustomerNote(booking.bookingUuid, note);
      this.context.addBookingNote(data || note);
      this.setState({ confirmLoading: false });
      closePopup();
    } catch (error) {
      message.error(get(error, 'response.data.message', error.message));
      this.setState({ confirmLoading: false });
    }
  };

  render() {
    const { customer, closePopup, openedPopup } = this.props;

    return (
      <Modal
        title="Please Confirm"
        visible={openedPopup === 'MuteFeedbackModal'}
        onOk={this.muteFeedback}
        onCancel={closePopup}
        cancelText="No"
        okText="Yes"
        confirmLoading={this.state.confirmLoading}
      >
        <P>
          Press "Yes" to stop the automated Trustpilot feedback request being send to this customers email
          address: {customer.email}?
        </P>
      </Modal>
    );
  }
}

export default MuteFeedbackModal;
